module.exports = __webpack_public_path__ + "img/symbol_4.70b111f0.png";